<template>
  <div>
    <section class="c-cbr-PageSection">
      <div class="o-flex c-cbr-PageSection-form">
        <obj-button
          :is-active="true"
          class="o-button is-active is-wide"
          is-wide
          @click="enableSummary()"
        >{{ $t('btn.check_order_details') }}</obj-button
        >
      </div>
    </section>

    <section
      :style="{ color: pageTextColor }"
      class="c-cbr-PageSection">
      <div
        v-if="showSummary"
        :class="$style.summaryOuter"
        class="c-cbr-HeaderPadding"
        data-scroll-to="container-summary"
      >
        <div :class="$style.summaryHeadline">{{ $t('summary.content') }}</div>

        <div :class="$style.summaryContent">
          <div>{{ formData.name }}</div>
          <div>{{ countries[formData.country] }}</div>
          <div>{{ formData.address }}</div>
          <div
            v-if="formData.country === 'IE'">
            {{ formData.postal_code.toUpperCase() }} {{ formData.city }}</div>
          <div
            v-else>
            {{ formData.postal_code }} {{ formData.city }}</div>

          <div>{{ formData.email }}</div>
        </div>

        <section class="c-cbr-PageSection-form">
          <div class="o-flex c-cbr-PageSection-form">
            <obj-button
              :is-active="!createReturnInProgress"
              :is-disabled="createReturnInProgress"
              class="o-button is-wide"
              @click="sendReturn()"
            >
              <span v-if="!createReturnInProgress">{{
                $t('summary.confirm_free_drop_shop_print')
              }}</span>
              <obj-spinner v-else />
            </obj-button>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { mapGetters, mapState, mapActions } from 'vuex'

import ObjPageContainer from './ObjPageContainer.vue'
import ObjButton from './ObjButton.vue'
import ObjSpinner from './ObjSpinner.vue'

export default {
  components: {
    ObjPageContainer,
    ObjButton,
    ObjSpinner
  },

  data() {
    return {

      showSummary: false,
      createReturnInProgress: false,
    }
  },

  computed: {
    ...mapGetters('config', ['countries', 'pageTextColor']),
    ...mapGetters('dropShops', ['selectedDropShop']),
    ...mapState('inputData', ['formData'])
  },

  methods: {
    ...mapActions('inputData', ['createReturn', 'commit']),

    sendReturn() {
      this.createReturnInProgress = true

      this.createReturn(this.selectedDropShop)
        .then(data => {
          this.data = data

          return this.commit(data)
        })
        .catch(() => {
          this.createReturnInProgress = false
        })
    },

    enableSummary() {
      this.showSummary = true
      Vue.nextTick(() => {
        VueScrollTo.scrollTo('[data-scroll-to="container-summary"]')
      })
    }
  }
}
</script>

<style module>
.summaryOuter {
  margin-right: auto;
  margin-left: auto;
  max-width: 680px;
}

.summaryHeadline {
  font-size: 2rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 0.7em;
}

.summaryContent {
  font-size: 1.0625rem;
  font-weight: 300;
  text-align: center;
  margin-bottom: 0.7em;

  div {
    margin-bottom: 0.2em;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/CbrSummary.vue